export enum ContractType {
    CDI = "CDI",
    INTERMITTENT = "Intermittent",
}
